import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    height: "94%",
    marginTop: "0px",
  },
  listContainer: {
    border: "1px solid #000000",
    borderRadius: "5px",
    height: "100%",
  },
  listItemBtn: {
    borderBottom: "1px solid black",
    transition: "none !important",
    "&:hover": {
      backgroundColor: "#BBBBBB",
    },
  },
  listItmBtnSelected: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#BBBBBB",
    },
  },
  listIcon: {
    minWidth: "35px",
  },
  tableRowHeadService: {
    width: "20%",
    padding: "8px",
  },
  tableHead: {
    borderBottom: "1px solid white",
  },
  tableRowCells: {
    fontSize: "16px",
  },
  tableRowCellsColor: {
    color: "#666666",
    padding: "10px",
  },
  //invitation table
  tableRowHeadInvitation: {
    width: "40%",
  },
  tableRowHeadInvitationTwo: {
    width: "17%",
  },
  centerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loaderContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  //myservicetable
  serviceTableBtn: {
    margin: "0px 15px 0px 0px",
    padding: "3px 10px",
    border: "2px solid #000000",
    borderRadius: "5px",
    textTransform: "none",
    color: "#000000",
    "&:hover": {
      backgroundColor: "#D9D9D9",
    },
    "&:disabled": {
      color: "#BBBBBB",
      border: "2px solid #BBBBBB",
    },
  },
}));

export default useStyles;
